import {
  PROD_EXTERNAL,
  QA_EXTERNAL,
  DEV_EXTERNAL,
  PROD_INTERNAL,
  QA_INTERNAL,
  DEV_INTERNAL,
  UAT,
  PROD_EXTERNAL_AKS,
  QA_EXTERNAL_AKS,
  STG_EXTERNAL_AKS,
  PROD_INTERNAL_AKS,
  QA_INTERNAL_AKS,
  STG_INTERNAL_AKS,
  DEV_INTERNAL_AKS,
  QA_PLANT_AKS,
  PROD_PLANT_AKS,
  DEV_INTERNAL_VIT_HUB,
  QA_INTERNAL_VIT_HUB,
  DEV_INTERNAL_VIT,
  QA_INTERNAL_VIT,
  STG_INTERNAL_VIT,
  PROD_INTERNAL_VIT,
  DEV_EXTERNAL_VIT,
  QA_EXTERNAL_VIT,
  STG_EXTERNAL_VIT,
  PROD_EXTERNAL_VIT,
  DEV_PLANT_VIT,
  QA_PLANT_VIT,
  STG_PLANT_VIT,
  PROD_PLANT_VIT,
} from 'utils/constants'

// TODO: Move to .env file
export const getApiHost = () => {
  const urlMap = new Map([
    [PROD_EXTERNAL, 'chec-dtna.prd.freightliner.com'],
    [QA_EXTERNAL, 'chec-dtna-test.qa.freightliner.com'],
    [DEV_EXTERNAL, 'chec-dtna-dev.dev.freightliner.com'],
    [UAT, 'chec-dtna-stg.qa.freightliner.com'],
    [PROD_INTERNAL, 'chec-dtna.app.corpintra.net'],
    [QA_INTERNAL, 'chec-dtna-test.app.corpintra.net'],
    [DEV_INTERNAL, 'dtna-checapi-dev.app.corpintra.net'],
    [PROD_EXTERNAL_AKS, 'chec-dtna.na.daimlertruck.com'],
    [QA_EXTERNAL_AKS, 'chec-dtna-test.na.daimlertruck.com'],
    [STG_EXTERNAL_AKS, 'chec-dtna-stg.na.daimlertruck.com'],
    [PROD_INTERNAL_AKS, 'chec-dtna.cloud.tbintra.net'],
    [QA_INTERNAL_AKS, 'chec-dtna-test.cloud.tbintra.net'],
    [STG_INTERNAL_AKS, 'chec-dtna-stg.cloud.tbintra.net'],
    [DEV_INTERNAL_AKS, 'chec-dtna-uat.cloud.tbintra.net'],
    [QA_PLANT_AKS, 'chec-plant-test.cloud.tbintra.net'],
    [PROD_PLANT_AKS, 'chec-plant.cloud.tbintra.net'],
    // VIT platform (same-origin via VirtualService)
    [
      DEV_INTERNAL_VIT_HUB,
      'chec-dev.vehicleit.210-az-np-hub001.cloud.tbintra.net',
    ],
    [
      QA_INTERNAL_VIT_HUB,
      'chec-qa.vehicleit.210-az-np-hub001.cloud.tbintra.net',
    ],
    [DEV_INTERNAL_VIT, 'chec.vit-dev.cloud.tbintra.net'],
    [QA_INTERNAL_VIT, 'chec.vit-qa.cloud.tbintra.net'],
    [STG_INTERNAL_VIT, 'chec.vit-prod-001.cloud.tbintra.net'],
    [PROD_INTERNAL_VIT, 'chec.vit.cloud.tbintra.net'],
    [DEV_EXTERNAL_VIT, 'chec.vit-dev.daimlertruck.com'],
    [QA_EXTERNAL_VIT, 'chec.vit-qa.daimlertruck.com'],
    [STG_EXTERNAL_VIT, 'chec.vit-stg.daimlertruck.com'],
    [PROD_EXTERNAL_VIT, 'chec.vit.daimlertruck.com'],
    [DEV_PLANT_VIT, 'chec-plant.vit-dev.cloud.tbintra.net'],
    [QA_PLANT_VIT, 'chec-plant.vit-qa.cloud.tbintra.net'],
    [STG_PLANT_VIT, 'chec-plant.vit-prod-001.cloud.tbintra.net'],
    [PROD_PLANT_VIT, 'chec-plant.vit.cloud.tbintra.net'],
  ])

  const currentHostName = window.location.hostname
  return urlMap.get(currentHostName)
}

/**
 * Get normalized API host (hostname only, no protocol)
 * Handles cases where REACT_APP_API_HOST includes https://
 * Falls back to getApiHost(), then window.location.host
 */
export const getNormalizedApiHost = () => {
  let host = process.env.REACT_APP_API_HOST

  // Strip protocol if present
  if (host) {
    host = host.replace(/^https?:\/\//, '')
  }

  // Fall back to hostname mapping
  if (!host) {
    host = getApiHost()
  }

  // Ultimate fallback: use current host (same-origin)
  if (!host) {
    host = window.location.host
  }

  return host
}
